const memoryMonitor = () => {
  let lastUsedHeap: number;
  let incrementRecord: number[] = [];
  let init: boolean = true;
  let count: number = 0;
  let hasReported = false;

  const MemoryEvent = {
    SINGLE: 'single',
    MULTIPLE: 'multiple',
    REGULAR: 'regular',
  };

  const oneMB = 1024 * 1024;
  // 多次内存增长总和限制
  const MULTIPLE_INCREMENT_LIMIT = oneMB * 200;
  // 单此内存使用率限制 ( 已使用 / 上限 )
  const MAX_USAGE_RATE = 50;
  // 常规上报的频率
  const REGULAR_REPORT_COUNT = 10;
  // 多次总和上报的总和记录数量
  const MULTIPLE_REPORT_COUNT = 5;

  const bytesToSize = (bytesArr: number[]) => bytesArr.map(bytes => Math.round(bytes / oneMB));

  onmessage = res => {
    const { usedJSHeapSize, jsHeapSizeLimit } = res.data;
    const dValue = init ? 0 : usedJSHeapSize - (lastUsedHeap ?? 0);
    init = false;
    lastUsedHeap = usedJSHeapSize;
    const size = bytesToSize([usedJSHeapSize, dValue, jsHeapSizeLimit]);
    // worker中使用解构赋值 jest 报错
    const usedSize = size[0],
      diffSize = size[1],
      limitSize = size[2];
    const usageRate = Number(((usedJSHeapSize * 100) / jsHeapSizeLimit).toFixed(2));

    const report = (type: string, increment?: number) => {
      const message = {
        type,
        increment,
        usedSize,
        limitSize,
        usageRate,
      };
      if (increment !== undefined) {
        message.increment = increment;
      }
      postMessage(message);
    };

    if (count++ >= REGULAR_REPORT_COUNT - 1) {
      report(MemoryEvent.REGULAR);
      count = 0;
    }

    if (incrementRecord.length < MULTIPLE_REPORT_COUNT) {
      incrementRecord.push(dValue);
      if (!hasReported && usageRate > MAX_USAGE_RATE) {
        hasReported = true;
        report(MemoryEvent.SINGLE, diffSize);
      }
    } else {
      let isPersist = true;
      let totalDValue = incrementRecord.reduce((pre, cur) => {
        if (cur < 0) {
          isPersist = false;
        }
        return pre + cur;
      }, 0);
      incrementRecord = [];
      // 五秒内持续上涨并且大于 200 MB 时 上报
      if (isPersist && totalDValue > MULTIPLE_INCREMENT_LIMIT) {
        // worker中使用解构赋值 jest 报错
        const size = bytesToSize([totalDValue]);
        report(MemoryEvent.MULTIPLE, size[0]);
      }
    }
  };
};

const getMonitorWorker = () => {
  const code = memoryMonitor.toString();
  return `data:text/javascript;charset=utf-8,(${code})()`;
};

export const memMonitorWorker = getMonitorWorker();
